import { render } from "./footer.vue?vue&type=template&id=73c66efb&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=73c66efb&scoped=true&lang=css"

import exportComponent from "D:\\project\\weetgo\\doo3dexamples\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c66efb"]])

export default __exports__